module.exports = __webpack_public_path__ + "img/Interacting.4c55e4fb.svg";